import LayoutBasic from "@/views/layouts/LayoutBasic";
import AutolistsCreate from "@/views/admin/autolists/Create";
import drugsOrderImport from "@/views/drugs/orderImport";
import drugsOrderImport2 from "@/views/drugs/orderImport2";
import AutolistsCreateNew from "@/views/admin/autolists/CreateNew";
import AutolistsCreateFiltered from "@/views/admin/autolists/CreateNewFiltered";
import AutolistsCreateFilteredNew from "@/views/admin/autolists/CreateNewFilteredNew";
import AutoList2 from "@/views/admin/autolists/AutoList2";
import AutolistSettings from "@/views/admin/autolists/AutolistSettings";
import AutolistsPrepsInReserve from "@/views/admin/autolists/prepsInReserve";
import AutolistsRejectedOrders from "@/views/admin/autolists/rejectedOrders";
import TransfersPlan from "@/views/admin/invoices/Plan";
import UsefulStore from '@/views/admin/autolists/UsefulStore.vue';

const routes = {
  path: '/autolists',
  component: LayoutBasic, // Change the desired Layout here
  meta: {requiresAuth: true},
  children: [
    {
      path: 'create',
      name: 'AutolistsCreate',
      component: AutolistsCreate
    },
    {
      path: 'order',
      name: 'drugsOrderImport',
      component: drugsOrderImport
    },
    {
      path: 'order2',
      name: 'drugsOrderImport2',
      component: drugsOrderImport2
    },
    {
      path: 'createnew',
      name: 'AutolistsCreateNew',
      component: AutolistsCreateNew
    },
    {
      path: 'createnewfiltered',
      name: 'AutolistsCreateFiltered',
      component: AutolistsCreateFiltered
    },
    {
      path: 'createnewfilteredNew',
      name: 'AutolistsCreateFilteredNew',
      component: AutolistsCreateFilteredNew
    },
    {
      path: 'autolist2',
      name: 'AutoList2',
      component: AutoList2
    },
    {
      path: 'settings',
      name: 'AutolistSettings',
      component: AutolistSettings
    },
    {
      path: 'prepsinreserve',
      name: 'AutolistsPrepsInReserve',
      component: AutolistsPrepsInReserve
    },
    {
      path: 'rejectedOrders',
      name: 'AutolistsRejectedOrders',
      component: AutolistsRejectedOrders
    },
    {
      path: 'transfersplan',
      component: TransfersPlan,
      name: 'TransfersPlan',
      meta: {
        accessName: 'invoices/transfersPlan'
      }
    },
    {
      path: 'stores/useful',
      component: UsefulStore,
      name: 'AutoListUsefulStore',
      meta: {
        accessName: 'autolists/usefulStores'
      }
    },
  ]
}

export default routes;
